module.exports = __webpack_public_path__ + "static/media/lemon.cac4c23a.png";